import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { callGetCollectionMetadataDetails } from '@app/client/resources/collection.ts';
import { PathParams } from '@app/routes/types';

export function useGetCollectionMetadata(slug = '', disabled = false) {
    const { [PathParams.CollectionSlug]: collectionSlugParam } = useParams();
    const collectionSlug = collectionSlugParam ? collectionSlugParam : slug;

    const response = useQuery({
        queryKey: ['collectionPageDetails', collectionSlug],
        queryFn: ({ signal }) =>
            callGetCollectionMetadataDetails({
                slug: collectionSlug || '',
                query: {
                    includeAttributes: true,
                    includeOwnerCount: true,
                    includeSalesCount: true,
                },
                settings: {
                    signal,
                },
            }),
        retry: false,
        placeholderData: keepPreviousData,
        enabled: Boolean(collectionSlug) && !disabled,
    });

    return { ...response, isError: response.isError || (!response.isLoading && !response.data?.collection) };
}
